import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createViolationFailed, createViolationSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED, OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import { normalizeCreateViolationError } from '../violationErrors';

export default function* createViolation(action) {
  try {
    const url = `${BACKEND_URL}/violations/`;
    const form = new FormData();
    const payload = action.payload || {};

    ['vehicle_id', 'provider_id', 'violation_type', 'status', 'description', 'inspector_id'].forEach(key => {
      if (payload[key]) {
        form.append(key, payload[key]);
      }
    });

    if (payload.location) {
      form.append('location', typeof payload.location === 'string' ? payload.location : JSON.stringify(payload.location));
    }

    if (Array.isArray(payload.photos)) {
      payload.photos.forEach(photo => {
        form.append('photos', photo);
      });
    }

    const response = yield makeRequest(url, form, action, 'POST', true, {}, true);
    if (response.status === OK || response.status === CREATED) {
      const data = yield getBodyJson(response);
      yield put(createViolationSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      const data = yield getBodyJson(response);
      const normalizedData = normalizeCreateViolationError(data);
      yield put(createViolationFailed());
      yield call(rejectActionPromise(action, normalizedData));
    }
  } catch (e) {
    yield put(createViolationFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
